var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrowse1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_6412)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_260_6412)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_260_6412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5172 20.3479L36.7967 2.21643C36.1861 1.18741 35.1924 0.44248 34.0334 0.144905C32.8745 -0.152672 31.6449 0.0213918 30.614 0.62894L4.71317 15.9438C4.20278 16.2453 3.75682 16.6444 3.40075 17.1184C3.04469 17.5924 2.7855 18.1319 2.638 18.706C2.49051 19.2801 2.45758 19.8778 2.54113 20.4646C2.62467 21.0515 2.82303 21.6162 3.12488 22.1264L13.8454 40.2571C14.1456 40.7685 14.5444 41.2152 15.0185 41.5715C15.4928 41.9277 16.0328 42.1864 16.6075 42.3324C16.9769 42.4274 17.3568 42.4756 17.7381 42.4757C18.544 42.4752 19.3348 42.2576 20.0273 41.8454L45.9297 26.5305C46.9587 25.92 47.7037 24.9262 48.0013 23.7673C48.2989 22.6083 48.1247 21.3787 47.5172 20.3479Z",
    fill: "#E6ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6053 15.0452H6.23264L4.71317 15.9437C4.20278 16.2452 3.75682 16.6443 3.40075 17.1183C3.04469 17.5923 2.7855 18.1318 2.638 18.706C2.49051 19.2801 2.45758 19.8777 2.54113 20.4646C2.62467 21.0514 2.82303 21.6162 3.12488 22.1263L13.8454 40.2571C14.1457 40.7684 14.5444 41.2151 15.0185 41.5714C15.4928 41.9276 16.0328 42.1863 16.6075 42.3323C16.9769 42.4275 17.3568 42.4756 17.7381 42.4756C18.544 42.4753 19.3348 42.2575 20.0273 41.8454L42.128 28.7783V22.5679C42.1255 20.5734 41.3323 18.6614 39.922 17.2512C38.5117 15.8409 36.5997 15.0475 34.6053 15.0452Z",
    fill: "#C8D5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6041 18.0543H4.51358C2.0208 18.0543 0 20.0751 0 22.5679V43.6312C0 46.124 2.0208 48.1448 4.51358 48.1448H34.6041C37.0968 48.1448 39.1176 46.124 39.1176 43.6312V22.5679C39.1176 20.0751 37.0968 18.0543 34.6041 18.0543Z",
    fill: "#E6ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 24.0724H39.1176V31.595H0V24.0724Z",
    fill: "#C40808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5414 45.1358H4.51429C4.11526 45.1358 3.73258 44.9772 3.45043 44.6951C3.16828 44.4129 3.00977 44.0303 3.00977 43.6312C3.00977 43.2322 3.16828 42.8496 3.45043 42.5673C3.73258 42.2852 4.11526 42.1267 4.51429 42.1267H13.5414C13.9405 42.1267 14.3231 42.2852 14.6053 42.5673C14.8874 42.8496 15.046 43.2322 15.046 43.6312C15.046 44.0303 14.8874 44.4129 14.6053 44.6951C14.3231 44.9772 13.9405 45.1358 13.5414 45.1358Z",
    fill: "#C40808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0641 40.6221H4.51429C4.11526 40.6221 3.73258 40.4636 3.45043 40.1815C3.16828 39.8993 3.00977 39.5167 3.00977 39.1176C3.00977 38.7186 3.16828 38.336 3.45043 38.0537C3.73258 37.7716 4.11526 37.6131 4.51429 37.6131H21.0641C21.4631 37.6131 21.8457 37.7716 22.128 38.0537C22.4101 38.336 22.5686 38.7186 22.5686 39.1176C22.5686 39.5167 22.4101 39.8993 22.128 40.1815C21.8457 40.4636 21.4631 40.6221 21.0641 40.6221Z",
    fill: "#C40808"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_6412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.1448,
    height: 48.1448,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_260_6412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.1448,
    height: 48.1448,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_260_6412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.1448,
    height: 48.1448,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowse1);
export default __webpack_public_path__ + "static/media/browse1.9d6cbd26d7d2c603324231863da226ce.svg";
export { ForwardRef as ReactComponent };